import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { VideocallSessionService } from '../services/videocall-session.service';

export const sessionGuard: CanActivateFn = () => {
  const session = inject(VideocallSessionService);
  const router = inject(Router);

  if (session.getSessionToken() || session.getSessionHash()) {
    return true;
  }

  return router.createUrlTree(['/home']);
};

export const callGuard: CanActivateFn = () => {
  const session = inject(VideocallSessionService);
  const router = inject(Router);

  const hasToken = !!session.getSessionToken();
  const hasPermissions = session.getPermissionsGranted();
  const hasJoinInfo = !!session.getJoinInfo();

  if (hasToken && session.isTokenExpired()) {
    console.warn('[callGuard] token expired, redirecting to entry');
    session.clearSessionToken();
    const hash = session.getSessionHash();
    return hash ? router.createUrlTree([`/${hash}`]) : router.createUrlTree(['/home']);
  }

  if (hasToken && hasPermissions && hasJoinInfo) {
    return true;
  }

  if (hasToken) {
    return router.createUrlTree(['/lobby']);
  }

  return router.createUrlTree(['/home']);
};
